import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

function PermaDeleteReportButton(props) {
  const [show, setShow] = useState(false);

  const [deleteInProgress, setDeleteInProgress] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (event) => {
    event.stopPropagation();
    setShow(true);
  }

  const onDelete = (event) => {
    setDeleteInProgress(true);
    props.deleteReport(props.report, "perma-delete");
    setShow(false);
  }

  const tooltip = (
    <Tooltip>Permanently delete</Tooltip>
  )

  return (
    <>
      <OverlayTrigger placement="top" overlay={tooltip}>
        <Button onClick={handleShow} className="reportActionButton btn-danger" disabled={deleteInProgress}>
          { 
            !deleteInProgress ? 
            <FontAwesomeIcon icon={solid("bomb")} className="buttonIcon" /> :
            <FontAwesomeIcon className="spinner buttonIcon" icon={solid("spinner")} />
          }
        </Button>
      </OverlayTrigger>
      
      <div style={{display: "none"}} onClick={(e) => e.stopPropagation()}>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Permanently delete report?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>This report will be lost forever. Really delete the report?</p>
            <p><strong>Name:</strong> { props.report.name }</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={onDelete}>Delete forever!</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default PermaDeleteReportButton;